import { Observable } from 'rxjs';

export interface DivisionMst {
  id?: any;
  divisionId?: any;
  divisionName: string;
  stateId: any;
  stateName?: string;
  description?: string;
  isActive: boolean;
  createdBy?: number;
}

export abstract class DivisionMstData {
  abstract list(url: string): Observable<any>;
  abstract getById(url: string): Observable<DivisionMst>;
  abstract create(url: string, data: DivisionMst): Observable<any>;
  abstract update(url: string, data: DivisionMst): Observable<any>;
}
